// import { ImagePreview } from 'vant'
import {
  ipqQueryCourseData,
  queryArgsToId,
  queryIdToArgs
} from '../../api/index.js'
import merge from 'webpack-merge'
import axios from 'axios'
export default {
  name: 'ipq-detail-page',
  data () {
    return {
      currentPage: 1,
      allPage: 1,
      dataList: [],
      loading: false,
      finished: false,
      scrollTop: 0,
      time: null,
      scrollToptitle: '',
      peopleList: [{
        name: '全部',
        value: null
      },
      {
        name: 'IEPQ线上项目',
        value: 30
      },
      {
        name: 'IEPQ 1V1',
        value: 42
      },
      {
        name: 'IEPQ 1V3',
        value: 48
      },
      {
        name: 'IEPQ线下项目',
        value: 50
      }
      ],
      imgBig: '',
      imgBigShow: false,
      searchName: '',
      tabActive: { name: '全部', value: null },
      imageCache: new Map() // 缓存已加载的图片

    }
  },
  watch: {
    scrollTop: function (newVal, oldVal) {
      if (this.dataList.length) {
        if (newVal > 330) {
          this.$nextTick(() => {
            this.scrollToptitle = this.dataList[Math.floor((newVal / 240))].level2
          })
        } else {
          this.scrollToptitle = this.dataList[0].level2
        }
      }
    }
  },
  created () {
    this.setWXShareInfo()
  },
  mounted () {
    const that = this
    window.addEventListener('scroll', function () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
    }, true)
  },
  methods: {
    // 样式换行
    getLine (index) {
      this.$nextTick(() => {
        const noticeDom = this.$refs[index][0]
        const notice1 = noticeDom.parentNode.nextSibling.firstElementChild
        const style = window.getComputedStyle(noticeDom, null)
        const style1 = window.getComputedStyle(notice1, null)
        const row = Math.floor(
          Number(style.height.replace('px', '')) /
          Number(style.lineHeight.replace('px', ''))
        )
        const row1 = Math.floor(
          Number(style1.height.replace('px', '')) /
          Number(style1.lineHeight.replace('px', ''))
        )
        if (row >= 4) {
          noticeDom.style.cssText = 'line-clamp:4;-webkit-line-clamp:4'
          notice1.style.cssText = 'line-clamp:2;-webkit-line-clamp:2'
        }
        if (row1 > 3) {
          notice1.style.cssText = 'line-clamp:3;-webkit-line-clamp:3'
        }
      })
    },
    clicktab (item) {
      this.tabActive = item
      this.searchInput()
    },
    async searchInput () {
      this.currentPage = 1
      this.list = []
      this.dataList = []
      this.finished = false
      clearTimeout(this.time)
      this.time = setTimeout(async () => {
        await this.getAllDataOnSearch(1)
      }, 800)
    },
    async getAllDataOnSearch (type) {
      const args = await this.getArgs(type)
      await this.onLoad(args)
    },
    async getArgs (type) {
      const args = {
        page: this.currentPage,
        limit: 20,
        type: this.tabActive.value,
        name: this.searchName
      }
      // 如果没有ID去换取ID 如果是搜索时候要重新获取id
      if (!this.$route.query.id || type === 1 || this.currentPage !== 1) {
        args.page = 1 // 传入后台1
        const result = await queryArgsToId({ args: args })
        this.$router.replace({ query: merge(this.$route.query, { id: result.data.id }) })
        // 调用列表数据传正常
        args.page = this.currentPage
        return args
      } else if (this.$route.query.id) {
        // const idRes = await queryArgsToId({ args: args })
        // this.$router.replace({ query: merge(this.$route.query, { id: idRes.data.id }) })
        const result = await queryIdToArgs({ id: this.$route.query.id })
        // 第一次记录的参数
        if (result && result.data && result.data.args) {
          this.initData(result.data.args)
          return result.data.args
        } else {
          return args
        }
      }
    },
    async initData (myargsObj) {
      // 如果是从连接跳转过来的有搜索默认数据
      if (myargsObj.page) {
        this.currentPage = myargsObj.page
      }
      if (myargsObj.difficulty) {
        const obj = this.peopleList.find(item => item.value === myargsObj.difficulty)
        if (obj) {
          this.tabActive = obj
        } else {
          this.tabActive = { name: '全部', value: null }
        }
      }
      if (myargsObj.name) {
        this.searchName = myargsObj.name
      }
    },
    async initOnLoad () {
      const args = await this.getArgs()
      await this.onLoad(args)
    },
    async onLoad (args) { // 异步更新数据
      clearTimeout(this.time)
      this.time = setTimeout(async () => {
        const list = await ipqQueryCourseData(args)
        if (list.data.courseList.length === 0) {
          this.finished = true
          return
        }
        if (list.data.courseList.length > 0) {
          this.dataList = [...this.dataList, ...list.data.courseList]
        }
        this.allPage = list.data.allPage
        this.currentPage += 1
        this.loading = false
      }, 600)
    },
    godetail (item) {
      if (item.isCanGoInfo) {
        const origin = window.location.origin
        if (process.env.NODE_ENV === 'development') {
          window.open('https://sou-m-testserver.gecacademy.cn/share?id=' + item.id)
        } else {
          if (origin.indexOf('-testserver') > -1) {
            window.open('https://sou-m-testserver.gecacademy.cn/share?id=' + item.id)
          } else {
            window.open('https://sou-m.gecacademy.cn/share?id=' + item.id)
          }
        }
      }
    },
    // 查看图片
    async show_before_img (item) {
      console.log(item)
      this.imgBig = item
      // this.imgBigShow = true
      // 检查缓存
      if (this.imageCache.has(this.imgBig)) {
        this.imgBigShow = true
      } else {
        // 显示加载中
        const loadingToast = this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
        try {
          await this.preloadImage(this.imgBig)
          loadingToast.clear()
          this.imgBigShow = true
        } catch (error) {
          loadingToast.clear()
          this.$toast('图片加载失败')
        }
      }
      // ImagePreview({
      //   images: [item],
      //   showIndex: false,
      //   closeOnPopstate: true,
      //   closeable: true
      // })
    },
    preloadImage (url) {
      return new Promise((resolve, reject) => {
        if (this.imageCache.has(url)) {
          resolve()
          return
        }
        const img = new Image()
        img.onload = () => {
          this.imageCache.set(url, true)
          resolve()
        }
        img.onerror = reject
        img.src = url
      })
    },
    closeImgBig () {
      this.imgBig = ''
      this.imgBigShow = false
    },
    async setWXShareInfo () {
      const currentRouter = this.$router.currentRoute.fullPath
      const basehref = `https://sou-tools.gecacademy.cn${currentRouter}`
      const shareTitle = 'Path Academics'
      const shareDesc = 'Light Your Path. Walk Your Way.'
      // const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/smallSearch/share/share.jpeg'
      const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/upload/2021-04-30%2016-47-46-WechatIMG4292.jpeg'
      const shareInfo = {
        title: shareTitle,
        desc: shareDesc,
        link: basehref,
        imgUrl: shareImgUrl,
        success () {},
        cancel () {}
      }
      const test = Math.random()
      const timestamp = parseInt(new Date() / 1000)
      const params = {
        timestamp,
        noncestr: String(test),
        url: basehref,
        appName: 'sou-tools'
      }
      // const result = await axios.get('https://api.gecacademy.cn/pay/wx/signature', {
      //   params
      // })
      // const signature = result.data.data
      const result = await axios.post('https://gec-api.gecacademy.cn/souapi/wechat/sellTool/getSign', params)
      const signature = result.data.data.signature
      const wx = this.$wx
      await wx.configAsync({
        debug: false,
        appId: 'wxf88eda53c74e883f',
        timestamp,
        nonceStr: String(test),
        signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage'
        ]
      })
      wx.onMenuShareTimeline(shareInfo)
      wx.onMenuShareAppMessage(shareInfo)
      wx.updateAppMessageShareData(shareInfo)
      wx.updateTimelineShareData(shareInfo)
    },
    goHome () {
      this.$router.push({ path: '/' })
    }
  }
}
